import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { EndpointService } from "@app/endpoint/endpoint.service";
import { TestCaseService } from "@app/testcase/testcase.service";
import { ToastrService } from "ngx-toastr";
import { TestsuiteService } from "@app/testsuite/testsuite.service";

import { Role } from "@app/_models";
import { MastersuiteService } from "@app/mastersuite/mastersuite.service";
import { CommonService } from "@app/_services";
import { SharedUtilService } from "../shared-util.service";
import { constants } from "@assets/data/constants";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Location } from "@angular/common";

@Component({
  selector: "app-option-bar",
  templateUrl: "./option-bar.component.html",
  styleUrls: ["./option-bar.component.less"],
})
export class OptionBarComponent implements OnChanges, OnInit {
  readonly TYPE_ENDPOINT = "ENDPOINT";
  readonly TYPE_TESTCASE = "TESTCASE";
  readonly TYPE_TESTSUITE = "TESTSUITE";
  readonly TYPE_MASTERSUITE = "MASTERSUITE";
  readonly TYPE_USER = "USER";
  readonly TYPE_GOPHER = "GOPHER";
  readonly TYPE_EXECUTION_HISTORY_TESTCASE = "HISTORY_TESTCASE";
  readonly TYPE_EXECUTION_RESULTS_TESTCASE = "RESULTS_TESTCASE";

  readonly AND = "AND";
  readonly OR = "OR";

  readonly ADMIN = Role[0].role;
  readonly DEVELOPER = Role[1].role;
  readonly TESTER = Role[2].role;
  readonly VIEWER = Role[3].role;
  @Input() type: string;
  @Input() isSettingEnabled = true;
  @Input() isListPage = false;
  @Input() details: any = {};
  @Input() isTestcaseTestdata = false;
  @Input() isImportCurl = false;
  @Input() displayCURLInput: any;
  @Input() createNewEndpointForm: FormGroup;

  @Output() executeTrigger: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() executeClone: EventEmitter<any> = new EventEmitter<any>();
  @Output() importExportHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedTestcaseEnv : EventEmitter<any> = new EventEmitter<any>();
  @Output() environments = new EventEmitter();
  @Output() projectwebConfigtool = new EventEmitter<any>();

  activeEnv: any[];
  OsTypes: any[];
  browserTypes: any[];
  selectedEnv = null;
  selectedOS: any;
  selectedBrowser: any;
  testDataForm: FormGroup;
  id: any;
  webConfigtool:any;
  testDataList: any = [];

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private endpointService: EndpointService,
    private testcaseServices: TestCaseService,
    private testsuiteService: TestsuiteService,
    private mastersuiteService: MastersuiteService,
    private commonService: CommonService,
    private sharedUtilService: SharedUtilService,
    private location: Location,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.testDataForm = this.fb.group({
      selectedTestDataList: []
    });
  }
  ngOnChanges() {
    if (this.details.id) {
      this.id = this.details.id;
      this.selectedEnv = null;
      this.OsTypes = JSON.parse(localStorage.getItem("about")).oss;
      this.browserTypes = JSON.parse(localStorage.getItem("about")).browserTypes;

      if(this.details.project.projectConfig.preferences) {
        /* Get OS dropdown */
        if(this.details.project.projectConfig.preferences.osType !== null && this.details.project.projectConfig.preferences.osType !== undefined) {
          this.selectedOS = this.details.project.projectConfig.preferences.osType;
        } else {
          this.selectedOS = this.OsTypes[0];
        }

        /* Get OS dropdown */
        if(this.details.project.projectConfig.preferences.browserType !== null && this.details.project.projectConfig.preferences.browserType !== undefined) {
          this.selectedBrowser = this.details.project.projectConfig.preferences.browserType;
        } else {
          this.selectedBrowser = this.browserTypes[1];
        }
      } else {
        this.selectedOS = this.OsTypes[0];
        this.selectedBrowser = this.browserTypes[1];
      }

      if (this.type === this.TYPE_ENDPOINT && this.details.id) {
        this.getEndpointActiveEnv(this.details.id);
        this.getProjectWebConfig(this.details.project.id);
      }
      if (this.type === this.TYPE_TESTCASE && this.details.project) {
        this.getTestcaseEnv(this.details.project.id);
        this.getProjectWebConfig(this.details.project.id);
        if(this.details.mobileTestCase || this.details.desktopTestCase) {
          this.getTestDataList(this.details.id);
        }
      }
      if (this.type === this.TYPE_TESTSUITE && this.details.project) {
        this.getTestsuiteEnv(this.details.project.id);
        this.getProjectWebConfig(this.details.project.id);
      }
      if (this.type === this.TYPE_MASTERSUITE && this.details.project) {
        this.getMastersuiteEnv(this.details.project.id);
        this.getProjectWebConfig(this.details.project.id);
      }
    }
  }

  changeEnv(item){
    this.selectedTestcaseEnv.emit(item)
  }

  /* Get endpoint active environments */
  getEndpointActiveEnv(id: number) {
    this.endpointService.getActiveEnv(id).subscribe((data) => {
      if (data.code === 200) {
        this.activeEnv = data.response;
        if( this.details.project.projectConfig.preferences !== undefined && this.details.project.projectConfig.preferences.environment !== null && this.details.project.projectConfig.preferences.environment !== undefined) {
          let selectedEnvironment = this.activeEnv.filter((item) => {
            if(item.id == this.details.project.projectConfig.preferences.environment) return item
          });
          if(selectedEnvironment.length > 0) {
            this.selectedEnv = selectedEnvironment[0];
          }
        }
      } else {
        this.activeEnv = [];
      }
    });
  }
  getProjectWebConfig(id: number) {
    this.endpointService.getProjectWebConfig(id).subscribe((data) => {
      if (data.code === 200) {
        this.webConfigtool = data.response;
        this.projectwebConfigtool.emit(data.response.WEB_AUTOMATION_TOOL);
        if (data.response.WEB_AUTOMATION_TOOL === 'PLAYWRIGHT') {
          this.browserTypes = JSON.parse(localStorage.getItem("about")).browserTypes_playwrightUi;
          if(this.details.project.projectConfig.preferences) {
            /* Get OS dropdown */
            if(this.details.project.projectConfig.preferences.osType !== null && this.details.project.projectConfig.preferences.osType !== undefined) {
              this.selectedOS = this.details.project.projectConfig.preferences.osType;
            } else {
              this.selectedOS = this.OsTypes[0];
            }

            /* Get Browser Types */
            if(this.details.project.projectConfig.preferences.browserType !== null && this.details.project.projectConfig.preferences.browserType !== undefined) {
              this.selectedBrowser = this.details.project.projectConfig.preferences.browserType;
            } else {
              this.selectedBrowser = this.browserTypes[0];
            }
          } else {
            this.selectedOS = this.OsTypes[0];
            this.selectedBrowser = this.browserTypes[1];
          }
        }
      } else {
        this.webConfigtool = { WEB_AUTOMATION_TOOL: 'SELENIUM' };
      }
    });
  }

  /* Get environment of testcase */
  getTestcaseEnv(id: any) {
    this.testcaseServices.getEnvByTestcaseId(id, this.id).subscribe((data) => {
      if (data.code === 200) {
        this.activeEnv = data.response;
        this.environments.emit(this.activeEnv);
        if(this.details.project.projectConfig.preferences && this.details.project.projectConfig.preferences !== undefined && this.details.project.projectConfig.preferences.environmentMapper !== null && this.details.project.projectConfig.preferences.environmentMapper !== undefined) {
          let selectedEnvironmentMapper = this.activeEnv.filter((item) => {
            if(item.id == this.details.project.projectConfig.preferences.environmentMapper) return item
          });
          if(selectedEnvironmentMapper.length > 0) {
            this.selectedEnv = selectedEnvironmentMapper[0];
          }
          this.changeEnv(this.selectedEnv);
        }else if(this.activeEnv?.length === 1){
          this.selectedEnv = this.activeEnv[0];
        }
      }
    });
  }

  /* Get environment of testsuite */
  getTestsuiteEnv(id: any) {
    this.testsuiteService.getEnv(id).subscribe((data) => {
      if (data.code === 200) {
        this.activeEnv = data.response;
        if(this.details.project.projectConfig.preferences !== undefined && this.details.project.projectConfig.preferences.environmentMapper !== null && this.details.project.projectConfig.preferences.environmentMapper !== undefined) {
          let selectedEnvironmentMapper = this.activeEnv.filter((item) => {
            if(item.id == this.details.project.projectConfig.preferences.environmentMapper) return item
          });
          if(selectedEnvironmentMapper.length > 0) {
            this.selectedEnv = selectedEnvironmentMapper[0];
          }
        }else if(this.activeEnv?.length === 1){
          this.selectedEnv = this.activeEnv[0];
        }
      }
    });
  }

  /* Get environment of mastersuite */
  getMastersuiteEnv(id: number) {
    this.mastersuiteService.getEnv(id).subscribe((data) => {
      if (data.code === 200) {
        this.activeEnv = data.response;
        if(this.details.project.projectConfig.preferences !== undefined && this.details.project.projectConfig.preferences.environmentMapper !== null && this.details.project.projectConfig.preferences.environmentMapper !== undefined) {
          let selectedEnvironmentMapper = this.activeEnv.filter((item) => {
            if(item.id == this.details.project.projectConfig.preferences.environmentMapper) return item
          });
          if(selectedEnvironmentMapper.length > 0) {
            this.selectedEnv = selectedEnvironmentMapper[0];
          }
        }else if(this.activeEnv?.length === 1){
          this.selectedEnv = this.activeEnv[0];
        }
      }
    });
  }

  execute(data) {
    this.executeTrigger.emit(data);
  }

  clone() {
    let cloneObject = JSON.parse(JSON.stringify(this.details));

    if (this.type === this.TYPE_ENDPOINT) {
      cloneObject.endPointTestInput.forEach(element => {
        if(element.customDate !== undefined) {
          delete element.customDate;
        }
        if (element.testInputKey.visibility) {
          element.testInputKey.visibility = "PUBLIC";
        } else {
          element.testInputKey.visibility = "PRIVATE";
        }
      });
      if (cloneObject.requestBody) {
        if (typeof cloneObject.requestBody === "object") {
          cloneObject.requestBody = JSON.stringify(cloneObject.requestBody);
        }
      }
    }

    if (this.type === this.TYPE_TESTCASE) {
      const testCaseURL = this.router.serializeUrl(this.router.createUrlTree(["testcase/new-clone", this.details.id]));
      window.open(location.origin + "/" + this.location.prepareExternalUrl(testCaseURL));
      return;
    }

    this.commonService.clone(this.type, cloneObject).subscribe((data) => {
      if (data.code === 200) {
        this.toastr.success(data.message);
      }
      this.routeToCloned(data.response.id);
    });
  }

  delete() {
    const confirmMsg = constants.deleteEntity + this.type + " ?";
    this.sharedUtilService.openConfirmDialog(confirmMsg, false).then((result) => {
      if (result) {
        this.commonService.delete(this.type, this.details).subscribe((data) => {
          if (data.code === 200) {
            this.toastr.success(data.message);
          }
          this.routeToList();
        });
      }
    });
  }

  /* Execute the endpoint */
  executeEndpoint(OS: any, browser: any, env: any) {
    const envSpecific = this.details.environmentSpecific;
    const data = {
      browserType: "",
      os: "",
    };

    if (browser) {
      data.browserType = browser;
    }
    if (OS) {
      data.os = OS;
    }

    if (envSpecific) {
      this.endpointService.executeWithEnv(this.details.id, env.id, data).subscribe((res) => {
        if (res.code === 200) {
          const executionId = res.response;
          this.toastr.success(res.message);
          const url = "/endpoint/" + this.details.id + "/result?noSqlId=" + executionId;
          this.router.navigateByUrl(url);
        } else {
          this.toastr.error(res.message);
        }
      });
    } else {
      this.endpointService.executeStart(this.details.id, data).subscribe((res) => {
        if (res.code === 200) {
          const executionId = res.response;
          this.toastr.success(res.message);
          const url = "/endpoint/" + this.details.id + "/result?noSqlId=" + executionId;
          this.router.navigateByUrl(url);
        } else {
          this.toastr.error(res.message);
        }
      });
    }
  }

  /* Execute testcase */
  executeTestcase(OS: string, browser: string, env: any, selectedTestDataList: any) {
    let finalSelectedTestDataList = [];
    if(selectedTestDataList === null) {
      finalSelectedTestDataList = [];
    } else {
      finalSelectedTestDataList = selectedTestDataList.map((item) => {
        return item.sequenceNumber;
      });
    }

    const data = {
      browserType: "",
      os: "",
      testDataSequenceList : finalSelectedTestDataList
    };

    if (browser) {
      data.browserType = browser;
    }
    if (OS) {
      data.os = OS;
    }

    this.testcaseServices.executorStart(this.details.id, env.id, data).subscribe((res) => {
      if (res.code === 200) {
        this.toastr.success(res.message);
        const url = "/testcase/" + this.details.id + "/result?executionId=" + res.response;
        this.router.navigateByUrl(url);
      } else {
        this.toastr.error(res.message);
      }
    });
  }

  /* Execute testsuite */
  executeTestsuite(OS: string, browser: string, env: any) {
    const data = {
      browserType: "",
      os: "",
    };

    if (browser) {
      data.browserType = browser;
    }
    if (OS) {
      data.os = OS;
    }

    this.testsuiteService.executionStart(this.id, env.id, data).subscribe((resp) => {
      if (resp.code === 200) {
        this.toastr.success(resp.message);
        const url = "/testsuite/" + this.details.id + "/result?noSqlId=" + resp.response;
        this.router.navigateByUrl(url);
      } else {
        this.toastr.error(resp.message);
      }
    });
  }

  /* Execute mastersuite */
  executeMasterSuite(OS: string, browser: string, env: any) {
    const data = {
      browserType: "",
      os: "",
    };

    if (browser) {
      data.browserType = browser;
    }
    if (OS) {
      data.os = OS;
    }

    this.mastersuiteService.executionStart(this.id, env.id, data).subscribe((resp) => {
      if (resp.code === 200) {
        this.toastr.success(resp.message);
        const url = "/mastersuite/" + this.details.id + "/result?noSqlId=" + resp.response;
        this.router.navigateByUrl(url);
      } else {
        this.toastr.error(resp.errorStatus);
      }
    });
  }

  /* Route To Appropriate Repository */
  routeToCloned(param: any) {
    switch (this.type) {
      case this.TYPE_ENDPOINT:
        const endPointURL = this.router.serializeUrl(this.router.createUrlTree(["endpoint", param]));
        window.open(location.origin + "/" + this.location.prepareExternalUrl(endPointURL));
        break;
      case this.TYPE_TESTCASE:
        const testCaseURL = this.router.serializeUrl(this.router.createUrlTree(["testcase", param]));
        window.open(location.origin + "/" + this.location.prepareExternalUrl(testCaseURL));
        break;
      case this.TYPE_TESTSUITE:
        const testSuiteURL = this.router.serializeUrl(this.router.createUrlTree(["testsuite", param]));
        window.open(location.origin + "/" + this.location.prepareExternalUrl(testSuiteURL));
        break;
      case this.TYPE_MASTERSUITE:
        const masterSuiteURL = this.router.serializeUrl(this.router.createUrlTree(["mastersuite", param]));
        window.open(location.origin + "/" + this.location.prepareExternalUrl(masterSuiteURL));
        break;
    }
  }

  routeToList() {
    switch (this.type) {
      case this.TYPE_ENDPOINT:
        this.router.navigate(["endpoint"]);
        break;
      case this.TYPE_TESTCASE:
        this.router.navigate(["testcase"]);
        break;
      case this.TYPE_TESTSUITE:
        this.router.navigate(["testsuite"]);
        break;
      case this.TYPE_MASTERSUITE:
        this.router.navigate(["mastersuite"]);
        break;
    }
  }

  truncateEnvName(name: string): string {
    const maxLength = this.webConfigtool?.WEB_AUTOMATION_TOOL === 'PLAYWRIGHT'?18:26; // Set the desired max length
    if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...';
    }
    return name;
  }

  handleImportExport(type: string) {
    this.importExportHandler.emit(type);
  }

  getTestDataList(testcaseId: any) {
    this.testcaseServices.getTestDataList(testcaseId).subscribe((data) => {
      if (data.code === 200) {
        this.testDataList = data.response;
        this.testDataForm.get("selectedTestDataList").setValue(this.testDataList);
      }
    });
  }

  selectAll() {
    this.testDataForm.get("selectedTestDataList").setValue(this.testDataList);
  }

  unselectAll() {
    this.testDataForm.get("selectedTestDataList").setValue([]);
  }

  setSelectAll(event: any) {
    if(event.target.checked) {
      this.selectAll();
    } else {
      this.unselectAll();
    }
  }

  getCheckedValue(testdataList, selectedTestDataList) {
    if(testdataList.length === selectedTestDataList.length) {
      return true;
    } else {
      return false;
    }
  }
}
